import React, { useEffect } from "react";

export const SessionExpired = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.href.match(/\?.*/)[0]);
    const path = params?.get("path") || "/";
    window.location.href = path;
  }, []);
  return <></>;
};
